import orderIssuesAPI from '../../api/orderIssues';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
  },
};

export const getters = {
  getOrderIssues(_state) {
    return _state.records;
  },
  getActiveCount(_state) {
    const count = _state.records.filter(issue => !issue.done && !issue.archived_at).length;
    return count;
  },
  getConversationOrderIssuesCount: (_state) => (conversationId) => {
    if (!conversationId) return 0;
    return _state.records.filter(
      issue => issue.conversation_id === conversationId && !issue.done && !issue.archived_at
    ).length;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  async get({ commit }) {
    commit('setUIFlag', { isFetching: true });
    try {
      const response = await orderIssuesAPI.getActive();
      const data = response.data || response || [];
      commit('setOrderIssues', Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('[OrderIssues Store] Failed to fetch order issues:', error);
      commit('setOrderIssues', []);
    } finally {
      commit('setUIFlag', { isFetching: false });
    }
  },
};

export const mutations = {
  setOrderIssues(_state, data) {
    _state.records = data;
  },
  setUIFlag(_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
